import { abbreviateNumber } from '@src/utils/data';
import { Header } from '@Components/StickyTable/BPMTable';
import { TableProgressBar } from '@Components/TableProgressBar';
import { AmcNewToBrandTableRow } from './amc-new-to-brand-types';

export interface NewToBrandMaxValues {
  maxNtbRate: number;
  maxNtbRepeatRate: number;
}

const progressBarRenderer = (value: number, maxCompleted: number) => (
  <TableProgressBar label={`${value}%`} maxCompleted={maxCompleted} value={value} />
);

export const getNtbTableHeaders = (maxValues: NewToBrandMaxValues): Header[] => [
  {
    name: 'trackedAsin',
    label: 'ASIN'
  },
  {
    name: 'customersConverted',
    label: 'Customers Converted',
    flex: 1,
    minFlexWidth: 141,
    renderer: (data: AmcNewToBrandTableRow) => abbreviateNumber(data.customersConverted)
  },
  {
    name: 'purchases',
    label: 'Purchases',
    flex: 1,
    minFlexWidth: 141,
    renderer: (data: AmcNewToBrandTableRow) => abbreviateNumber(data.purchases)
  },
  {
    name: 'ntbCustomers',
    label: 'NTB Customers',
    flex: 1,
    minFlexWidth: 141,
    renderer: (data: AmcNewToBrandTableRow) => abbreviateNumber(data.ntbCustomers)
  },
  {
    name: 'ntbPurchases',
    label: 'NTB Purchases',
    flex: 1,
    minFlexWidth: 141,
    renderer: (data: AmcNewToBrandTableRow) => abbreviateNumber(data.ntbPurchases)
  },
  {
    name: 'ntbRate',
    label: 'NTB Rate',
    flex: 1,
    minFlexWidth: 141,
    renderer: (data: AmcNewToBrandTableRow) =>
      progressBarRenderer(data.ntbRate, maxValues.maxNtbRate)
  },
  {
    name: 'ntbRepeat',
    label: 'NTB Repeat',
    flex: 1,
    minFlexWidth: 141,
    renderer: (data: AmcNewToBrandTableRow) => abbreviateNumber(data.ntbRepeat)
  },
  {
    name: 'ntbRepeatRate',
    label: 'NTB Repeat Rate',
    flex: 1,
    minFlexWidth: 141,
    renderer: (data: AmcNewToBrandTableRow) =>
      progressBarRenderer(data.ntbRepeatRate, maxValues.maxNtbRepeatRate)
  }
];
